import axios from "axios";
import {getAuthHeader} from './auth';

 const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

export const fetchResearcherDetails = async (researcherId, skip, limit) => {
  const res = await axios.get(`${baseURL}/api/researcher`, {
    params: { researcherId, skip, limit },
    headers: getAuthHeader(),
  });
  return res.data;
}

export const fetchResearcherDetailId = async() =>{
    const res = await axios.get(`${baseURL}/api/get-researcherid`)
    return res.data;
}